export default __webpack_public_path__ + "static/media/Sandro Fontes_.2d4527f8.png";